import React, { useEffect, useState } from "react";
import "./productrecommendations.scss";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import helperfunctions from "../../../utils/helperfunctions";
import { useSelector } from "react-redux";
import partsService from "../../../services/partsservice";
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import { selectors as headerSelector } from '../../../state/features/header';
import { TreeviewDropdown } from "../../CommonComponent";
import { Iprops } from "./productrecommendationsinterface";
import GetimageBaseURL from "../../../assets/images";
import Loader from "../../Loader";
import QuantityColumn from "../Quantity";
import distrubtorlogo from "../../../assets/images/distrubutorLogo.png";

const ProductRecommendation = (props: Iprops) => {
    const { t } = useTranslation();
    const imgUrl = GetimageBaseURL();
    const defaultProductImage = imgUrl + "ecommercecategoryimages/NoImage-Big.png";
    const [products, setProducts] = useState<any>([]);
    const [filteredProducts, setFilteredProducts] = useState<any>([]);
    const { globalData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
    }));
    const defaultOption = [{ title: t(RESOURCE.MyK_AppNotificationLabel_All), value: "" }]
    const [model, setModel] = useState<any>("");
    const [serial, setSerial] = useState<any>("");
    const [modelOptions, setModelOptions] = useState<any>(defaultOption);
    const [serialOptions, setSerialOptions] = useState<any>(defaultOption);
    const [isProductRecommendationLoading, setIsProductRecommendationLoading] = useState<any>(false);
    const [isAddingParts, setIsAddingParts] = useState(false)
    const { headercurrentuser }: any = useSelector(
        state => ({ headercurrentuser: headerSelector.currentuser(state) })
    );
    const isCart = ((props?.cartItem?.partNumber ?? "") == "");
    useEffect(() => {
        getProductRecommendationItem();
    }, [props?.cartItem])

    useEffect(() => {
        const filteredData = products?.filter((s: any) => (s.model == model || model == "") && (s.serialNumber == serial || serial == ""));
        setFilteredProducts(filteredData);
    }, [model, serial])

    const getProductRecommendationItem = () => {
        setIsProductRecommendationLoading(true);
        if ((props?.cartItem?.partNumber ?? "") != "") {
            partsService.getProductRecommendationByPartNumber(props?.cartItem?.partNumber, headercurrentuser?.azureADId, props?.cartItem?.machine?.model, props?.cartItem?.machine?.serial)
                .then((response: any) => {
                    getProductRecommendation(response);
                    setIsProductRecommendationLoading(false);
                })
                .catch((e: any) => {
                    helperfunctions.showErrorMessage(e);
                    setIsProductRecommendationLoading(false);
                });
        }
        else {
            partsService.getProductRecommendationByCartId(props?.cartsDetails?.cart?.cartId)
                .then((response: any) => {
                    getProductRecommendation(response);
                    setIsProductRecommendationLoading(false);
                })
                .catch((e: any) => {
                    helperfunctions.showErrorMessage(e);
                    setIsProductRecommendationLoading(false);
                });
        }
    }

    const getProductRecommendation = (response: any) => {
        const partsWithMachineQty = Array.isArray(response) ? response.map((part: any) => ({
            ...part,
            machine_qty: part?.quantity ?? 0
        })) : [];
        setProducts(partsWithMachineQty ?? []);
        setFilteredProducts(partsWithMachineQty)
        const models = partsWithMachineQty?.filter((s: any) => (s.model ?? "") != "")?.map((t: any) => t.model);
        const serials = partsWithMachineQty?.filter((s: any) => (s.serialNumber ?? "") != "")?.map((t: any) => t.serialNumber);
        const modelUniques = models.filter(function (item: any, pos: any) {
            return models.indexOf(item) == pos;
        }) ?? [];
        const serialUniques = serials.filter(function (item: any, pos: any) {
            return serials.indexOf(item) == pos;
        }) ?? [];
        const modelOpt = modelUniques.map((s: any) => ({ title: s, value: s }));
        const serialOpt = serialUniques.map((s: any) => ({ title: s, value: s }));
        setModelOptions([...defaultOption, ...modelOpt]);
        setSerialOptions([...defaultOption, ...serialOpt]);
    }

    const statusClass = (e: any) => {
        if (e > 0) {
            return "availablestatus";
        }
        else {
            return "contactstatus";
        }
    };

    const statusText = (e: any) => {
        if (e > 0) {
            return "AVAILABLE";
        }
        else {
            return "CONTACT DEALER";
        }
    };

    const getRequestBody = (item: any) => {
        return {
            cart: {
                PunchoutOrderRequestId: globalData?.punchOutRequestPartLogId ?? 0,
                userAadId: headercurrentuser?.azureADId,
                distributorCode: globalData.DistributorCode,
                branchCode: globalData.BranchCode,
                customerId: globalData.CustomerId ? parseInt(globalData.CustomerId) : 0,
                locationId: globalData.LocationId ? parseInt(globalData.LocationId) : 0
            },
            parts: [
                {
                    manufacturer: {
                        code: "",
                        name: item?.manufacturerName
                    },
                    partNumber: item?.partNumber,
                    quantity: item?.quantity,
                    machine: {
                        mDbId: 0
                    }
                }
            ]
        };
    }

    const addPartNumberService = async (item: any) => {
        const model = getRequestBody(item)
        setIsAddingParts(true);
        partsService.addPartNumber(model)
            .then((response: any) => {
                props?.updateIsPartAddedStatus(true);
                setIsAddingParts(false)
                if (response.isSuccessful) {
                    props.getMiningParts();
                    helperfunctions.showSuccessMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Success_Msg));
                }
                else
                    helperfunctions.showErrorMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Error_Msg));
            })
            .catch((e: any) => {
                setIsAddingParts(false)
                helperfunctions.showErrorMessage(e);
            });
    }

    const addPartNumber = (item: any) => {
        if ((item?.partNumber ?? "") == "") {
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Part_Number_Required));
        }
        else if ((item?.manufacturerName ?? "") == "") {
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Manufacture_Required));
        }
        else if (item?.quantity < 1 || item?.quantity > 9999) {
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Quantity_Validation));
        }
        else {
            addPartNumberService(item)
        }
    }

    const updateProduct = (item: any, isBookMarked: boolean) => {
        const productList = filteredProducts?.map((t: any) => {
            if (item.partNumber == t.partNumber) {
                return {
                    ...t,
                    isBookMarked: isBookMarked,
                };
            }
            else {
                return t;
            }
        });

        setFilteredProducts(productList);
    }

    const saveBookmark = (item: any) => {
        setIsProductRecommendationLoading(true);
        const model = [{
            userAadId: headercurrentuser?.azureADId,
            manufacturer: {
                code: "",
                name: item?.manufacturerName
            },
            partNumber: item?.partNumber,
            quantity: item?.quantity,
            partDescription: item?.description,
            distributorCode: globalData?.DistributorCode,
            branchCode: globalData?.BranchCode,
            model: item?.model,
            serialNumber: item?.serialNumber,
        }];

        partsService.saveBookmark(model)
            .then((response: any) => {
                if (response.isSuccess) {
                    helperfunctions.showSuccessMessageTop(t(RESOURCE.MyK_Label_SC_Partlist_Cart_Bookmark_Add));
                    updateProduct(item, true);
                    setIsProductRecommendationLoading(false);
                }
                else {
                    helperfunctions.showErrorMessageTop(response?.message ?? t(RESOURCE.MyK_Label_SC_Partlist_Cart_Bookmark_AddRemove_Error));
                    setIsProductRecommendationLoading(false);
                }
            })
            .catch((e: any) => {
                helperfunctions.showErrorMessageTop(e);
                setIsProductRecommendationLoading(false);
            });
    }

    const removeBookmark = (item: any) => {
        setIsProductRecommendationLoading(true);
        const model = [{
            userAadId: headercurrentuser?.azureADId,
            manufacturer: {
                code: "",
                name: item?.manufacturerName
            },
            partNumber: item?.partNumber,
            quantity: item?.quantity,
            partDescription: item?.description,
            model: item?.model,
            serialNumber: item?.serialNumber,
            distributorCode: globalData?.DistributorCode,
            branchCode: globalData?.BranchCode,
        }];

        partsService.removeBookmark(model)
            .then((response: any) => {
                if (response.isSuccess) {
                    helperfunctions.showSuccessMessageTop(t(RESOURCE.MyK_Label_SC_Partlist_Cart_Bookmark_Remove));
                    updateProduct(item, false);
                    setIsProductRecommendationLoading(false);
                }
                else {
                    helperfunctions.showErrorMessageTop(response?.message ?? t(RESOURCE.MyK_Label_SC_Partlist_Cart_Bookmark_AddRemove_Error));
                    setIsProductRecommendationLoading(false);
                }
            })
            .catch((e: any) => {
                setIsProductRecommendationLoading(false);
                helperfunctions.showErrorMessageTop(e);
            });
    }

    const updatePartsQuantity = (_: any, partNumber: any, prevQuatity: any, quantity: any) => {
        const products = filteredProducts?.length ? filteredProducts : [];
        const productList = products?.map((item: any) => {
            if (item.partNumber == partNumber) {
                return {
                    ...item,
                    quantity: quantity,
                };
            }
            else {
                return item;
            }
        });
        setFilteredProducts(productList);
    }

    return (
        <div className="productrecommendation-wrapper">
            {isAddingParts && <Loader />}
            <div className="producrecommendationtitle">
                { isCart ? t(RESOURCE.MyK_Label_ShoppingCart_Recommended_Based_On_Cart) : t(RESOURCE.MyK_Label_ShoppingCart_Recommended_Based_On) + " : " + props?.cartItem?.partNumber}
            </div>
            <div className="productrecommendationinputs mt-2">
                <div className="product_title">
                    <span>{t(RESOURCE.MyK_Label_ShoppingCart_Products)}</span>
                </div>

                <div className="productrecommendationinputfields">
                    <div className="input-view">
                        <div className="label">{t(RESOURCE.MyK_Label_Model)}</div>
                        <div className="product-field">
                            <TreeviewDropdown
                                treeData={modelOptions}
                                showSearch={false}
                                value={model}
                                onChange={(value: any) => { setModel(value) }}
                            />
                        </div>
                    </div>
                    <div className="input-view mb-sm-0 mb-4">
                        <div className="label">{t(RESOURCE.MyK_Label_Serial)}</div>
                        <div className="product-field">
                            <TreeviewDropdown
                                treeData={serialOptions}
                                showSearch={false}
                                value={serial}
                                onChange={(value: any) => { setSerial(value) }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="mulipleView mt-2">
                {isProductRecommendationLoading && <Loader />}
                {filteredProducts?.length == 0 && !isProductRecommendationLoading ?
                    <h4 className="text-center">{t(RESOURCE.MyK_Label_ShoppingCart_No_Records_Available)}</h4>
                    :
                    filteredProducts?.map((item: any) => (
                        <div className="card-wrapper" key={item.partNumber}>
                            <div className="product-card">
                                <img src={((item?.productImageUrl ?? "") == "") ? defaultProductImage : item.productImageUrl}
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        if (currentTarget.src != defaultProductImage) {
                                            currentTarget.src = defaultProductImage;
                                        }
                                    }}
                                    className="product_card-img" alt="product" />
                                {item?.isRemanPart && <img src={distrubtorlogo} alt="logo" className="distributorlogo" />}
                                <div className="lineview"></div>
                                {isCart && < div className="related-to-title">{t(RESOURCE.MyK_Label_SC_RelatedTo)}:
                                    {item.parentPartNumber?.split(",")?.map((t: any) =>
                                        <span key={t} className="related-part-number" onKeyDown={() => { }} onClick={() => { props.partNumberRedirect(t) }}>{t}</span>
                                    )}
                                </div>}
                                <div className="product-details">
                                    <div className="product-discription">
                                        <div className="truncate-text">{item.description}</div></div>
                                    <div className="product-price"><div className="priceView"><span>$</span>{helperfunctions.formatAmount(item?.unitPrice)}</div></div>
                                </div>
                                {item?.isPartAvailableInPIM ? <div className="productNo" onKeyDown={() => { }} onClick={() => { props.partNumberRedirect(item.partNumber) }}>{item.partNumber}</div> : 
                                    <div className="productNo_NoLink">{item.partNumber}</div>}
                                <div className="qty-details">
                                    <div className="qty-description">
                                        <div className="machine_qty">{`${t(RESOURCE.MyK_Label_SC_Machine_Qty)}: ${item?.machine_qty}`}</div></div>
                                    <div className="qty_field"><QuantityColumn cartDetailId={item?.cartDetailId} quantity={item?.quantity} partNumber={item?.partNumber} childPartNumber={null} updateCartQuantity={updatePartsQuantity} /></div>
                                </div>
                                <div className="product-actions clearfix">
                                    <div className="contactDealer">
                                        <div className={statusClass(item.availability)}>{statusText(item.availability)}</div>
                                    </div>
                                    <div className="actionmenus">
                                        <div className="wishlist mr-2" title={item.isBookMarked ? t(RESOURCE.MyK_Label_SC_Partlist_Cart_Remove_Bookmark) : t(RESOURCE.MyK_Label_SC_Partlist_Cart_Add_Bookmark)} onKeyDown={() => { }} onClick={() => item.isBookMarked ? removeBookmark(item) : saveBookmark(item)}><div className={item.isBookMarked ? "fa fa-check wishlistViewchecked" : "fa fa-bookmark wishlistView"}></div></div>
                                        <div className="addToCart"><button onClick={() => addPartNumber(item)} title={t(RESOURCE.MyK_Label_AddToCart)}>{t(RESOURCE.MyK_Label_ShoppingCart_Add)}<span className="fa fa-cart-plus ml-2"></span></button></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default ProductRecommendation;